<template>
  <section
    class="merge-button"
    :class="{ '--unavailable': !canMerge || !hasAccessToCloseOrCancel }"
  >
    <button
      v-if="canMerge"
      class="action-button"
      type="button"
      :disabled="!canMerge || !hasAccessToMerge"
      @click="onMergeClick"
    >
      {{ $t('message.merge') }}
    </button>
    <div
      v-else
      class="action-button"
    >
      {{ $t('message.merge') }}
    </div>
    <div
      v-click-outside="handleClickOutside"
      class="menu-block"
    >
      <button
        v-if="hasAccessToCloseOrCancel"
        class="menu-button"
        type="button"
        @click="isMenuOpened = !isMenuOpened"
      >
        <i class="gf-icon gf-icon-triangle-down-big"></i>
      </button>
      <div
        v-else
        class="menu-disabled"
      >
        <i class="gf-icon gf-icon-triangle-down-big"></i>
      </div>
      <div
        v-if="isMenuOpened && hasAccessToCloseOrCancel"
        class="menu"
      >
        <span
          class="item"
          @click="onCancelClick"
        >
          {{ $t('message.cancel_action') }}
        </span>
        <span
          class="item"
          @click="onCloseClick"
        >
          {{ $t('message.close_action') }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import { clickOutsideDirective } from '@/directives';

export default {
  name: 'MergeButton',
  directives: {
    'click-outside': clickOutsideDirective()
  },
  data() {
    return {
      isMenuOpened: false
    };
  },
  computed: {
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    canMerge() {
      return this.mergeRequest.canMerge && !this.mergeRequest?.autoMergeEnabled;
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    hasAccessToCloseOrCancel() {
      return this.getActionAvailabilityFlag(ACTION_ENUM.EDIT_STATUS_OF_MERGE_REQUEST);
    },
    hasAccessToMerge() {
      return this.getActionAvailabilityFlag(ACTION_ENUM.DO_MERGE_MERGE_REQUEST);
    }
  },
  methods: {
    handleClickOutside() {
      this.isMenuOpened = false;
    },
    onCancelClick() {
      this.isMenuOpened = false;
      this.$emit('cancel');
    },
    onCloseClick() {
      this.isMenuOpened = false;
      this.$emit('close');
    },
    onMergeClick() {
      this.isMenuOpened = false;
      if (this.canMerge) {
        this.$emit('merge');
      }
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    }
  }
};
</script>

<style lang="scss">
$this: '.merge-button';

#{$this} {
  min-height: 34px;
  display: flex;
  color: var(--real-white);
  background-color: var(--success);
  border: 1px solid var(--success);
  border-radius: 8px;

  &.--unavailable {
    background-color: var(--white);
    border-color: var(--warning);

    & > .action-button {
      color: var(--text-muted);
      background-color: var(--white);
    }

    & > .menu-block {
      & > .menu-button {
        background-color: var(--warning) !important;
        color: var(--text);

        &:hover {
          background-color: #cc9a28 !important;
        }
      }
    }
  }

  & > .action-button {
    min-height: 34px;
    padding: 6px;
    color: var(--real-white);
    background-color: var(--success);
    border: none;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  & > .menu-block {
    position: relative;

    & > .menu-button {
      min-height: 34px;
      padding: 6px;

      color: var(--real-white);
      border: none;
      background-color: var(--success);
      border-radius: 6px;
      transition: background-color 0.1s ease-in-out;

      &:hover {
        background-color: #189944;
      }
    }

    & > .menu-disabled {
      min-height: 34px;
      padding: 6px;

      color: var(--text-muted);
      border-radius: 8px;
    }

    & > .menu {
      min-width: 140px;
      position: absolute;
      bottom: -2px;
      left: 0;
      padding: 6px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      color: var(--text);
      background-color: var(--white);
      border-radius: 6px;
      border: 1px solid var(--border-color);
      transform: translateY(100%);

      & > .item {
        width: 100%;
        padding: 6px;
        border-radius: 6px;
        text-align: start;
        transition: background-color 0.05s ease-in-out;
        cursor: pointer;

        &:hover {
          background-color: var(--bg-light);
        }
      }
    }
  }
}
</style>
